import * as ActionCable from '@rails/actioncable'

function getCableURL () {
  const meta = document.querySelector('meta[name="Cable-URL"]')
  return meta && meta.content
}

export default ActionCable.createConsumer(getCableURL())
